module.exports = __webpack_public_path__ + "static/media/todos-in-person-meeting.90f37c51.svg";